import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '../loader-service/loader.service';
import { environment } from 'src/environments/environment';
import { map, finalize, of, delay, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasterDataServiceService {
  baseUrl = environment.baseUrl;
  public keysData: { allKeys: string[], selectedKeys: string[] } = { allKeys: [], selectedKeys: [] };
  constructor(public http: HttpClient, public loaderService: LoaderService) { }

  private hideLoaderWithDelay(): void {
    of(null)
      .pipe(delay(1000))
      .subscribe(() => {
        this.loaderService.hide();
      });
  }

  getAllMasterData(numberPerPage: number, pageIndex: number) {
    const requestBody = {
      requestType: "records",
      page: pageIndex,
      numberPerPage: numberPerPage,
      sorts: {
      }
    }
    return this.http.post<any>(this.baseUrl + 'v1/epcis/records/master', requestBody).pipe(
      map(records => {
        this.separateKeys(records.data);
        return records;
      }),
      finalize(() => this.hideLoaderWithDelay())
    );
  }

  onPageSizeChangeOfMasterDataOutbound(requestBody: any){
    return this.http.post<any>(this.baseUrl + 'v1/epcis/records/master', requestBody).pipe(
      map(records => {
        this.separateKeys(records.data);
        return records;
      }),
      finalize(() => this.hideLoaderWithDelay())
    );
  }

  separateKeys(records: any) {
    const allKeys: string[] = [];
    const selectedKeys: string[] = [];
    if (!Array.isArray(records)) {
      return { allKeys: [], selectedKeys: [] };
    }

    records.forEach((record: {}) => {
      if (record && typeof record === 'object') {
        Object.keys(record).forEach(key => {
          if (key !== 'id') {
            allKeys.push(key);
            selectedKeys.push(key);
          }
        });
      }
    });
    this.keysData.allKeys = [...new Set(allKeys)];
    this.keysData.selectedKeys = [...new Set(selectedKeys)];
    return this.keysData;
  }

  columnFilterDebounceAction(requestBody: any, isInbound: boolean) {
    const masterDataUrl = isInbound ? this.baseUrl + 'v1/epcis/records/inboundmaster/unique' : this.baseUrl + 'v1/epcis/records/master/unique';
    const finalRequestBody = isInbound
      ? { ...requestBody, page: 0, numberPerPage: 5000 }
      : requestBody;

    return this.http.post<any>(masterDataUrl, finalRequestBody).pipe(
      map((records: { status: number | string; total: number; uniqueData: Array<{ [key: string]: Array<any> }> }) => {
        return records;
      }),
      finalize(() => this.hideLoaderWithDelay())
    );
  }

  public getSortedRecordsForColumn(requestBody1: any, isMasterDataInbound: boolean): Observable<any> {
    this.loaderService.show();
    const req1 = requestBody1

    const masterDataUrl = isMasterDataInbound ? this.baseUrl + 'v1/epcis/records/inboundmaster/getAll' : this.baseUrl + 'v1/epcis/records/master';
    return this.http.post<any>(masterDataUrl, req1).pipe(
      map(records => {
        return records;
      }),
      finalize(() => this.hideLoaderWithDelay())
    );
  }

  updateEnableDisableState(payload: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'v1/epcis/records/master/update', payload);
  }


  
    public clearColumnsSubject = new Subject<void>();
  
    clearColumns$ = this.clearColumnsSubject.asObservable();
  
    triggerClearColumns() {
      this.clearColumnsSubject.next();
    }

  

}

